import { render } from "./ArchivedTariff.vue?vue&type=template&id=1e15afc4"
import script from "./ArchivedTariff.vue?vue&type=script&lang=js"
export * from "./ArchivedTariff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__